import React from "react";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import RegularCard from "../../mui-components/Card/RegularCard";
import FiSpreadsheetsTable from "../../containers/domain/fi-spreadsheet/FiSpreadsheetsTable";

const FiSpreadsheetsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de planilhas de ativos"
        content={<FiSpreadsheetsTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default FiSpreadsheetsListingView;
